export default __webpack_public_path__ + "static/bg_android_banner-031b6987999f2114bd49dc3a7e1fbbd0.webp";